import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { breakpointMd, breakpointLg } from '@fiverr-private/sass/helpers';
import { Masonry as PentaMasonry } from '@fiverr-private/masonry';

const useColumnCount = () => {
  const sm = useMediaQuery({ maxWidth: breakpointMd - 1 });
  const md = useMediaQuery({ maxWidth: breakpointLg - 1 });
  if (sm) {
    return 2;
  }
  if (md) {
    return 3;
  }
  return 4;
};

interface MasonryProps {
  children: React.ReactNode;
}

/**
 * A wrapper component over Penta's Masonry.
 * Takes care of columns count automatically.
 */
export const Masonry = ({ children }: MasonryProps) => {
  const columnCount = useColumnCount();
  return <PentaMasonry columnCount={columnCount}>{children}</PentaMasonry>;
};
